import { Typography } from '@mui/material';
import moment from "moment";
import {
  AutocompleteArrayInput,
  ChipField,
  Datagrid,
  DateField,
  Filter,
  NumberField,
  ReferenceArrayField,
  ReferenceArrayInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  SingleFieldList,
  TextField,
  useListContext,
  useTranslate,
  AutocompleteInput,} from "react-admin";
import { ReportList } from "../../components";
import { BetweenDatesInput } from "../../components/BetweenDatesInput";
import ListPagination from "../../components/ListPagination";
import Permission from "../../components/Permission";
import { PERMISSIONS } from "../../constants";
import { getChainId } from "../../lib";
import { filterToQuery } from "../../utils";

const FilterTablePrint = () => {
  const { filterValues } = useListContext();
  return (
    <Datagrid bulkActionButtons={false} data={[{ ...filterValues, generatedReportAt: moment().toISOString() }]} total={1}>
      <DateField source="from" textAlign="center" label="De" sortable={false} locales="pt-BR" />
      <DateField source="to" textAlign="center" label="Até" sortable={false} locales="pt-BR" />
      <ReferenceArrayField label="Posto" source="placeIds" textAlign="center" basePath="stations" reference="stations" link={false} >
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <DateField source="generatedReportAt" textAlign="center" label="Gerado às" showTime sortable={false} locales="pt-BR" />
    </Datagrid>
  );
};

const ReferedCustomersList = () => {
  const props = useListContext();

  let data = [], summaryData = [];

  if (props.data) {
    const reportInfo = props.data[0];

    if (reportInfo) {
      data = reportInfo.data;
      summaryData = [reportInfo.summaryData];
    }
  }

  return (
    <>
      <Typography sx={{ margin: '10px 0 10px 0', textAlign: 'center', fontWeight: 'bold' }}>Total</Typography>
      <Datagrid bulkActionButtons={false} style={{ marginBottom: 60 }} data={summaryData} total={1}>
        <NumberField source="cnt_rc" label="Clientes Indicadores" sortable={false} textAlign="center" />
        <NumberField source="cnt_customer" label="Número de Indicações" sortable={false} textAlign="center" />
      </Datagrid>
      <Typography sx={{ margin: '10px 0 10px 0', textAlign: 'center', fontWeight: 'bold' }}>Indicações</Typography>
      <Datagrid bulkActionButtons={false} style={{ marginTop: 40 }} data={data} total={1} resource={props.resource}>
        <ReferenceField
          reference="customers"
          source="referee_customer_id"
          label="Cliente que Indicou"
          link={false}
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="name" label="Cliente Indicado" />
        <DateField source="refered_at" label="Data da Indicação" emptyText="-" textAlign="center" showTime locales="pt-BR" />
        <DateField source="created_at" label="Data do Abastecimento" emptyText="-" textAlign="center" showTime locales="pt-BR" />
      </Datagrid>
    </>
  );
};

const ReferedCustomersFilter = (props) => {
  const { filterValues } = useListContext();
  const translate = useTranslate();

  return (
    <Filter {...props}>
      <BetweenDatesInput alwaysOn />
      <Permission permission={PERMISSIONS.ADMIN} alwaysOn>
        <ReferenceInput
          source="chainId"
          reference="chains"
          perPage={99999}
          sort={{ field: "name", order: "ASC" }}
          defaultValue={getChainId()}
        >
          <AutocompleteInput
            filterToQuery={filterToQuery}
            label="Rede"
            style={{ minWidth: 180 }}
            optionText={'name'}
          />
        </ReferenceInput>
      </Permission>
      <ReferenceArrayInput
        source="placeIds"
        reference="stations"
        filter={filterValues.chainId ? { chainId: filterValues.chainId } : {}}
        sort={{ field: "name", order: "ASC" }}
        perPage={null}
        alwaysOn
      >
        <AutocompleteArrayInput
          filterToQuery={filterToQuery}
          sx={{ minWidth: 180, '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': { minWidth: 50 } }}
          label="Posto"
          optionText="name"
          noOptionsText={translate('ra.input.autocomplete.no_options_text')}
        />
      </ReferenceArrayInput>
    </Filter>
  );
};

const ReportReferedCustomers = (props) => {
  return (
    <Permission permission={PERMISSIONS.REFERED_CUSTOMERS_REPORT}>
      <ReportList periodRequired
        {...props}
        basePath="report-refered-customers"
        title="Indicação"
        resource="chains/chainId/reports/refered-customers"
        filters={<ReferedCustomersFilter />}
        sort={{ field: "refered_at", order: "DESC" }}
        perPage={25}
        pagination={<ListPagination />}
        filterDefaultValues={{
          chainId: getChainId(),
          from: moment().subtract(1, 'month').startOf('day').toISOString(),
          to: moment().endOf('day').toISOString()
        }}
        bulkActionButtons={false}
        titleOnPrint="Relatório de Indicação"
        filterTablePrint={<FilterTablePrint />}
        landscape
      >
        <ReferedCustomersList />
      </ReportList>
    </Permission>
  );
};

export default ReportReferedCustomers;